import { render } from "./ProductCard.vue?vue&type=template&id=4bfb51c6"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=4bfb51c6&lang=css"

import exportComponent from "F:\\Beetronix\\Beetronix Front-end Task\\Al Radwan\\vue-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__